module.exports = __webpack_public_path__ + "static/media/truck_costco_scheduler.043b798a.jpg";